/**
 * TanStack Query hooks for `digitalocean-spaces-export-csv-json`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	digitaloceanSpacesExportCsvJsonQueryKeys,
	type CreateDigitaloceanSpacesExportCsvJsonBody,
	type ListDigitaloceanSpacesExportCsvJsonResponse,
	type DigitaloceanSpacesExportCsvJsonRow,
} from "./api";

export function useDigitaloceanSpacesExportCsvJsonList(): UseQueryResult<ListDigitaloceanSpacesExportCsvJsonResponse, Error> {
	return useQuery({
		queryKey: digitaloceanSpacesExportCsvJsonQueryKeys.list(),
		queryFn: list,
	});
}

export function useDigitaloceanSpacesExportCsvJsonCreate(): UseMutationResult<DigitaloceanSpacesExportCsvJsonRow, Error, CreateDigitaloceanSpacesExportCsvJsonBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: digitaloceanSpacesExportCsvJsonQueryKeys.all });
		},
	});
}

export function useDigitaloceanSpacesExportCsvJsonDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: digitaloceanSpacesExportCsvJsonQueryKeys.all });
		},
	});
}
